import { render } from "./tSidebar.vue?vue&type=template&id=7dcad604&scoped=true"
import script from "./tSidebar.vue?vue&type=script&lang=js"
export * from "./tSidebar.vue?vue&type=script&lang=js"

import "./tSidebar.vue?vue&type=style&index=0&id=7dcad604&lang=less&scoped=true"

import exportComponent from "D:\\codeDevelopment\\文稿通\\wgt_user_web_2.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcad604"]])

export default __exports__